import { useTranslation } from "react-i18next";

export function SearchRequestError({
  onRetry, retrying = false,
}: { onRetry: () => void; retrying?: boolean }) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-300 bg-amber-50 p-4 text-amber-950">
      <p>{t("search.request_failed", {
        defaultValue: "Search is temporarily unavailable. We couldn’t load fresh results. Please try again.",
      })}</p>
      <button
        type="button"
        disabled={retrying}
        onClick={onRetry}
        className="rounded-lg border border-current px-4 py-2 font-semibold disabled:cursor-wait disabled:opacity-50"
      >
        {retrying
          ? t("search.retrying", { defaultValue: "Retrying…" })
          : t("common.retry", { defaultValue: "Retry" })}
      </button>
    </div>
  );
}
